import { Grid } from "@mui/material";
import HeaderLabelTitle from "./HeaderLabelTitle";
import HeaderLabelValue from "./HeaderLabelValue";

// const HeaderLabelGridField = ({ title, value, dxs, tdxs = 0, ...props }) => {
const HeaderLabelGridField = ({ ...props }) => {
  let { title, value, dxs, tdxs, className } = props;
  if (dxs === undefined || dxs == 0) {
    dxs = 1;
  }
  if (tdxs === undefined || tdxs == 0) {
    tdxs = dxs;
  }

  return (
    <>
      <Grid item xs={tdxs} display="flex" gap={1}>
        <HeaderLabelTitle title={title} />
      </Grid>
      <Grid item xs={dxs} display="flex" gap={1}>
        {props?.fontFamily == "numberFontFamily" ? (
          <HeaderLabelValue
            value={value}
            fontFamily={props?.fontFamily}
            className={className}
          />
        ) : (
          <HeaderLabelValue value={value} className={className} />
        )}
      </Grid>
    </>
  );
};

export default HeaderLabelGridField;
